type Tone = "default" | "inverse" | "accent";

const TONE: Record<Tone, { base: string; iq: string }> = {
  default: { base: "text-text-primary", iq: "text-accent" },
  // Inverse renders over the purple gradient (Login). Hierarchy by brightness,
  // not hue: dim "Retention" + bright "IQ" gives the same emphasis pattern as
  // the default tone's purple "IQ" pop.
  inverse: { base: "text-white/70", iq: "text-white" },
  accent: { base: "text-accent", iq: "text-accent" },
};

export function Wordmark({
  tone = "default",
  size = "md",
}: {
  tone?: Tone;
  size?: "sm" | "md" | "lg" | "xl";
}) {
  const sizeClass = {
    sm: "text-base",
    md: "text-lg",
    lg: "text-2xl",
    xl: "text-4xl",
  }[size];
  const c = TONE[tone];
  return (
    <span
      className={`font-display font-semibold tracking-tight inline-flex items-baseline ${sizeClass}`}
      aria-label="MarketplacesIQ"
    >
      <span className={c.base}>Marketplaces</span>
      <span className={`font-extrabold ${c.iq}`}>IQ</span>
    </span>
  );
}
